module.exports = __webpack_public_path__ + "img/9.5fa5b655.jpg";